import { Box, Skeleton } from "@mui/material";
import { type FC, useState } from "react";
import { type RandomRange, randomBetween, randomCount } from "./skeletonVariants";

/** The plot area's width to height, wide like the app's charts; it gives the bars' percentage heights something to fill. */
const CHART_ASPECT_RATIO = "16 / 7";
/** How the chart varies per mount: how many bars it has, and each bar's height (% of the plot area). */
const CHART_RANGES = {
	bars: [8, 12],
	barHeight: [30, 95],
} as const satisfies Record<string, RandomRange>;

/** A chart's title over a row of bars at random heights, so each wait sketches a different-looking series. */
export const ChartSkeletonVariant: FC = () => {
	const [barHeights] = useState(() => Array.from({ length: randomCount(CHART_RANGES.bars) }, () => randomBetween(CHART_RANGES.barHeight)));

	return (
		<Box>
			<Skeleton variant="text" width="30%" />
			<Box sx={{ display: "flex", alignItems: "flex-end", gap: 1, mt: 2, width: "100%", aspectRatio: CHART_ASPECT_RATIO }}>
				{barHeights.map((height, index) => (
					// biome-ignore lint/suspicious/noArrayIndexKey: placeholder bars are a fixed series; nothing reorders them.
					<Skeleton key={index} variant="rounded" sx={{ flex: 1, height: `${height}%`, borderRadius: 1 }} />
				))}
			</Box>
		</Box>
	);
};
